import { render, staticRenderFns } from "./PowerShow.vue?vue&type=template&id=3448422a&scoped=true&"
import script from "./PowerShow.vue?vue&type=script&lang=js&"
export * from "./PowerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3448422a",
  null
  
)

export default component.exports